import React, {Fragment, Component} from 'react';
import styles from './Documents.module.sass';
import theme from '../../App.module.sass';
import TitleSection from '../../components/TitleSection/TitleSection';


import DocumentsType from "../../components/DocumentsType/DocumentsType";
import {Link} from "react-router-dom";

class Documents extends Component {

  render() {
    return (
      <Fragment>
        <div className={theme.contentColumns}>
          <div className={theme.mainContent}>

            <section className={theme.sectionForm}>
              <TitleSection title="Tá na mão"/>
              <DocumentsType
                bb={true}
                proposta={this.props.match.params.proposalId}/>

              <p>Para acompanhar as assembleias e ficar por dentro de tudo sobre seu consórcio, acesse o
                <a className={theme.link} href="https://arealogada.caixaseguradora.com.br" rel="noopener noreferrer" target="_blank"> Serviços ao Cliente. </a>
              </p>

            </section>

            <Link to="/produtos" className={[theme.link, styles.newSimulation].join(' ')}> Fazer uma nova simulação </Link>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Documents;
